// extracted by mini-css-extract-plugin
export default {"sign_in_title":"SignIn_sign_in_title__rhK1f","sign_in_subtitle":"SignIn_sign_in_subtitle__GBMV2"};